import { Component, OnInit } from '@angular/core';
//import { ColDef, GridOptions } from '@ag-grid-enterprise/all-modules';
import { ColDef, GridOptions, GridApi } from "ag-grid-community";
import { GridFormatterService } from '../../../common/services/grid-formatter.service';
import { Dialog, DialogButton } from '../../../core/models/dialog.model';
import { DynamicDialogService } from '../../../core/services/dynamic-dialog.service';
import { SubHeaderService } from '../../../core/services/sub-header.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { WellSearchResult, WellSearchSpec } from '../../../common/models/well.model';
import { Subscription } from 'rxjs';
import { WellService } from '../../../common/services/well.service';
import { SubHeader } from '../../../core/models/sub-header.model';
import { OnBaseKeywordMappingSearchSpec, OnBaseMappedKeyword } from '../../../common/models/onBaseIntegrationAndMapping.model';
import { map } from 'rxjs/operators';
import { DocumentManagementService } from '../../../common/services/document-management.service';
import { TitleCasePipe } from '@angular/common';
import { ButtonRendererComponent } from "../../../common/components/ag-grid/button-renderer.component";
import { LoaderService } from '../../../common/services/loader.service';

@Component({
    selector: 'app-delete-api',
    templateUrl: './delete-api.component.html',
    styleUrls: ['./delete-api.component.scss'],
    standalone: false
})
export class DeleteApiComponent implements OnInit {

    form: FormGroup;
	gridOptions: GridOptions;
	gridApi?: GridApi;
    private countySubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
    private townshipSubject: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
    countyObservable: Observable<string[]> = this.countySubject.asObservable();
    townshipObservable: Observable<string[]> = this.townshipSubject.asObservable();
    private subheader = new SubHeader({ title: "Delete API" });
    private selectedApiNumber: string = '';

    wellSearched: boolean = false;
    dropdownDefault: string = "--";
    disableSearch: boolean = true;
    searchActive: boolean = false;

    results: WellSearchResult[] = null;

    subscription: Subscription = new Subscription();


    get apiNumber(): string {
        if (this.form == null) return "";
        const ctrl = this.form.get("apiNumber");
        if (ctrl == null) return "";
        return ctrl.value;
    }

    get selectedCounty(): string {
        if (this.form == null) return this.dropdownDefault;
        const ctrl = this.form.get("county");
        if (ctrl == null) return this.dropdownDefault;
        return ctrl.value;
    }

    get selectedTownship(): string {
        if (this.form == null) return this.dropdownDefault;
        const ctrl = this.form.get("township");
        if (ctrl == null) return this.dropdownDefault;
        return ctrl.value;
    }

    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    get invalidAPI(): boolean {
		return this.apiNumber == null || this.apiNumber.length != 14;
	}

	get invalidCounty(): boolean {
		return this.selectedCounty == null || this.selectedCounty.length == 0 || this.selectedCounty == this.dropdownDefault;
	}

	get invalidTownship(): boolean {
		return this.selectedTownship == null || this.selectedTownship.length == 0 || this.selectedTownship == this.dropdownDefault;
	}

    get invalid(): boolean {
		return this.invalidAPI && this.invalidCounty && this.invalidTownship;
    }

    confirmAPIDeleteDialog: Dialog = new Dialog("Are you sure you want to delete this API and its associated data?", [new DialogButton("Confirm Delete", true, () => { this.deleteData() }), new DialogButton("Cancel", false, () => { this.handleCancel() })]);
    deleteSuccesfulDialog: Dialog = new Dialog("Delete Successful", [new DialogButton("OK", true, () => { this.searchWells();})]);
    constructor(private subheaderSvc: SubHeaderService, private casePipe: TitleCasePipe, private docService: DocumentManagementService, private wellService: WellService, private formatter: GridFormatterService,
        public dialogService: DynamicDialogService, private builder: FormBuilder,  private readonly loader: LoaderService) {
        
    }

    ngOnInit() {

        this.countySubject.next([this.dropdownDefault]);
        this.townshipSubject.next([this.dropdownDefault]);
        this.form = this.builder.group({
            apiNumber: ["", []],
            county: [this.dropdownDefault, []],
            township: [this.dropdownDefault, []]
        });

        this.gridOptions = this.formatter.BuildDefaultGridOptionsWithColumns(this.createColumnDefinitions(), false, true, true, false);
        this.subheaderSvc.updateSubHeader(this.subheader);

        this.gridOptions.onGridReady = (params) => {
			this.gridApi = params.api;
			this.gridApi.sizeColumnsToFit();
        };

        const county$ = this.docService.findKeywordMappings({ keywordName: "DOGRM - County" } as OnBaseKeywordMappingSearchSpec)
            .pipe(
                map((keys: OnBaseMappedKeyword[]) => {
                    let options: string[] = [];
                    keys.forEach(k => { k.dropdownValues.forEach(v => { options.push(v.value); }); });
                    options = options.filter(this.onlyUnique);
                    return options;
                })
            );

        const township$ = this.docService.findKeywordMappings({ keywordName: "DOGRM - Township" } as OnBaseKeywordMappingSearchSpec)
            .pipe(
                map((keys: OnBaseMappedKeyword[]) => {
                    let options: string[] = [];
                    keys.forEach(k => { k.dropdownValues.forEach(v => { options.push(this.casePipe.transform(v.value)); }); });
                    options = options.filter(this.onlyUnique);
                    return options;
                })
            );

        const dataObs$ = forkJoin([county$, township$]).pipe()
            .subscribe({
                next: ([countyList, townshipList]) => {
                    countyList.unshift(this.dropdownDefault);
                    this.countySubject.next(countyList);
                    townshipList.unshift(this.dropdownDefault);
                    this.townshipSubject.next(townshipList);
                    this.disableSearch = false;
                },
                error: (error) => { console.error(error); }
            });

        this.subscription.add(dataObs$);

    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    createColumnDefinitions(): ColDef[] {
        return [
            {
                headerName: "API #",
                headerTooltip: "API #",
                field: "id",
                tooltipField: "id",
                filter: "agTextColumnFilter",
                filterParams: this.formatter.defaultTextFilterParams,
                minWidth: 180
            } as ColDef,
            {
                headerName: "Well Name",
                headerTooltip: "Well Name",
                filter: "agTextColumnFilter",
                filterParams: this.formatter.defaultTextFilterParams,
				valueGetter: this.formatter.formatWellName("Unavailable"),
				tooltipValueGetter: this.formatter.formatWellName("Unavailable"),
                minWidth: 150
            } as ColDef,
            {
                headerName: "Well #",
                headerTooltip: "Well #",
                field: "wellNumber",
                tooltipField: "wellNumber",
                filter: "agTextColumnFilter",
                filterParams: this.formatter.defaultTextFilterParams,
                valueFormatter: this.formatter.formatPotentiallyBlankField("wellNumber", "Unavailable"),
                tooltipValueGetter: this.formatter.formatPotentiallyBlankField("wellNumber", "Unavailable"),
                minWidth: 150
            } as ColDef,
            {
                headerName: "RICS Owner #",
                headerTooltip: "RICS Owner #",
                field: "organizationId",
                tooltipField: "organizationId",
                filter: "agTextColumnFilter",
                filterParams: this.formatter.defaultTextFilterParams,
                minWidth: 145
            } as ColDef,
            {
                headerName: "RBDMS Owner #",
                headerTooltip: "RBDMS Owner #",
                field: "historicalOwnerNumber",
                tooltipField: "historicalOwnerNumber",
                filter: "agTextColumnFilter",
                filterParams: this.formatter.defaultTextFilterParams,
                minWidth: 145
            } as ColDef,
            {
                headerName: "Delete",
                headerTooltip: "Delete",
				field: "Delete",
				cellRenderer: ButtonRendererComponent,
				cellRendererParams: {
					action: (obj: any) => this.onDelete(obj),
					buttonText: "Delete"
				},
                flex: 2
            } as ColDef
        ] as ColDef[];
    }

    public onDelete(data: any) {
        this.selectedApiNumber = data.id;

        this.confirmAPIDeleteDialog.toggleDialog(true);
        this.dialogService.updateDialog(this.confirmAPIDeleteDialog);

    }

    public deleteData() {
        this.loader.toggleLoader(true);
		this.wellService.deleteWell(this.selectedApiNumber)
			.subscribe({
                next: (response) => {
                    this.deleteSuccesfulDialog.toggleDialog(true);
                    this.dialogService.updateDialog(this.deleteSuccesfulDialog);
                    this.loader.toggleLoader(false);
                },
                error: (error) => {
                    console.error('Error deleting API', error);
				    this.loader.toggleLoader(false);
				    this.dialogService.showError();
                }
        });
    }

    public handleCancel() {
        this.selectedApiNumber = '';
        this.confirmAPIDeleteDialog.toggleDialog(false);
    }

    searchWells(): void {
        if (!this.invalid) {
            const spec = {
                apiNumber: this.apiNumber,
                county: (this.selectedCounty != this.dropdownDefault) ? this.selectedCounty : "",
                township: (this.selectedTownship != this.dropdownDefault) ? this.selectedTownship : ""
            } as WellSearchSpec;
            this.searchActive = true;
            if (this.gridApi) this.gridApi.setGridOption("loading", true);
            const search$ = this.wellService.search(spec).pipe(
            ).subscribe(
               {
                    next: (wells: WellSearchResult[]) => {
                        this.results = wells;
                        this.searchActive = false;
                        this.wellSearched = true;
                        this.gridApi?.setGridOption("loading", false);
                    },
                    error: (error) => {
                        console.error(error);
                        this.searchActive = false;
                        this.gridApi?.setGridOption("loading", false);
                    }
               }
            );
            this.subscription.add(search$);
        }
    }   

}
